import './App.css';
import VirtualTabletScreen from './VirtualTabletScreen';

function VirtualTablet({
    campaign,
    height,
    width,
}) {
    return (
        <div
            style={{
                width: `${width}em`,
                height: `${height}em`,
                borderStyle: 'solid',
                borderColor: 'grey',
                borderRadius: '1em',
                backgroundColor: 'grey',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '1em',
                margin: '1em',
            }}
        >
            <VirtualTabletScreen
                campaign={campaign}
                height={`${height * 90 / 100}em`}
                width={`${width * 90 / 100}em`}
            />
        </div>
    )
}

export default VirtualTablet;